import { useQuery } from '@tanstack/react-query'
import { useSession } from '~/components/user/SessionProvider'
import { trpc } from '~/lib/trpc'

export function useOrganisationCandidate() {
  const { session } = useSession()
  const user = session?.user
  const hasEmailOrNewEmail = !!(user?.email || user?.new_email)

  return useQuery({
    ...trpc.users.getOrganisationCandidate.queryOptions(),
    enabled: !!session && hasEmailOrNewEmail,
  })
}
